{
  "name": "@radianos/radianbeta",
  "version": "1.1.7",
  "main": "index.js",
  "type": "module",
  "publishConfig": {
    "access": "public"
  },
  "exports": "./dist/index.js",
  "bin": {
    "radianos": "dist/index.js"
  },
  "scripts": {
    "dev": "tsup --watch",
    "build": "tsup"
  },
  "keywords": [
    "radian",
    "radianos",
    "radianos cli",
    "components",
    "ui",
    "tailwind",
    "radix-ui"
  ],
  "author": "Radian OS",
  "license": "ISC",
  "description": "Add components to your project",
  "dependencies": {
    "@clack/prompts": "^0.9.1",
    "adm-zip": "^0.5.16",
    "chalk": "^5.3.0",
    "commander": "^12.1.0",
    "cosmiconfig": "^9.0.0",
    "execa": "^9.5.0",
    "fast-glob": "^3.3.2",
    "fs-extra": "^11.2.0",
    "gradient-string": "^3.0.0",
    "json5": "^2.2.3",
    "node-fetch": "^3.3.2",
    "ora": "^8.1.0",
    "package-manager-detector": "^1.3.0",
    "prompts": "^2.4.2",
    "ts-morph": "^25.0.1",
    "tsconfig-paths": "^4.2.0",
    "tsup": "^8.3.5",
    "type-fest": "^4.26.1",
    "zod": "^3.23.8"
  },
  "devDependencies": {
    "@trivago/prettier-plugin-sort-imports": "^5.2.2",
    "@types/adm-zip": "^0.5.7",
    "@types/fs-extra": "^11.0.4",
    "@types/node": "^22.7.9",
    "@types/prompts": "^2.4.9",
    "prettier": "^3.4.2",
    "prettier-plugin-organize-imports": "^4.1.0",
    "typescript": "^5.6.3"
  },
  "packageManager": "pnpm@10.11.1+sha512.e519b9f7639869dc8d5c3c5dfef73b3f091094b0a006d7317353c72b124e80e1afd429732e28705ad6bfa1ee879c1fce46c128ccebd3192101f43dd67c667912"
}
